// extracted by mini-css-extract-plugin
export default {"form":"NNzM1jgD","mobile":"mobile","row":"WuAH32zo","field":"h2crLjVw","footer":"HI98D1bK"};